const TOP_STAR_PATH =
  'M28 22l1.2 3.6h3.8l-3.1 2.2 1.2 3.6L28 29.2l-3.1 2.2 1.2-3.6-3.1-2.2h3.8L28 22z';
const BOTTOM_LEFT_STAR_PATH =
  'M14 4l1.2 3.6h3.8l-3.1 2.2 1.2 3.6L14 11.2l-3.1 2.2 1.2-3.6-3.1-2.2h3.8L14 4z';
const BOTTOM_RIGHT_STAR_PATH =
  'M42 4l1.2 3.6h3.8l-3.1 2.2 1.2 3.6L42 11.2l-3.1 2.2 1.2-3.6-3.1-2.2h3.8L42 4z';

export function SectionAsterism() {
  return (
    <p className="section__asterism">
      <svg
        className="section__asterism__svg"
        viewBox="0 0 56 34"
        width="56"
        height="34"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path fill="currentColor" d={TOP_STAR_PATH} />
        <path fill="currentColor" d={BOTTOM_LEFT_STAR_PATH} />
        <path fill="currentColor" d={BOTTOM_RIGHT_STAR_PATH} />
      </svg>
    </p>
  );
}
